import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const DatetimeGlobalStyles = css`
  .DatetimeContainer {
    .rdtCounters {
      display: inline-flex;
      align-items: center;
      height: 258px;
    }
    .rdtCount,
    .rdtCounterSeparator {
      font-weight: normal;
    }
    .rdtCount {
      height: 25%;
    }
    .rdtBtn {
      color: #c9cbcd;
    }
    .rdtPicker {
      width: 100%;
      margin: 0;
      padding: 0;
      border: 2px solid rgba(201, 203, 205, 0.2);
      border-radius: 6px;
    }
    tfoot {
      border-top: 2px solid rgba(201, 203, 205, 0.2);
    }
    .rdtSwitch {
      padding: 14px;
      font-size: 18px;
    }
    .rdtPrev,
    .rdtNext {
      vertical-align: middle !important;
    }
    .rdtPrev span,
    .rdtNext span {
      color: #c9cbcd;
      font-size: 32px;
    }
    .rdtTimeToggle {
      padding: 10px;
      font-size: 18px;
    }
    .dow {
      color: #5f6369;
      font-weight: normal;
      font-size: 14px;
    }
    .rdtDay {
      height: 32px;
      font-weight: normal;
      font-size: 16px;
    }
    .rdtDay:hover {
      background: transparent;
    }
    .rdtMonth,
    .rdtYear {
      height: 86px;
    }
    .rdtActive {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;
      border-radius: 100%;
      color: white;
      font-weight: bold;
      background: #5000b9 !important;
    }
    .rdtDay.rdtActive {
      width: 30px;
      height: 30px;
    }
    .rdtMonth.rdtActive,
    .rdtYear.rdtActive {
      width: 60px;
      height: 60px;
      margin: 13px 0px 13px 17px;
    }
  }
`;
